
export enum NamedQueries {
	GET_AUTH = 'GET_AUTH',
	GET_CREDITS = 'GET_CREDITS',
	GET_SANDBOXES = 'GET_SANDBOXES',
	GET_USER_MEMBERSHIPS = 'GET_USER_MEMBERSHIPS',
}
